import { Address } from 'viem';

export const cbBtcTokenAddress: Address = '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf';
